import apiClient from '../utils/axios-config';
import { CategoryMeta } from '../types/blog';
import { logger } from '../utils/logger';

class CategoryService {
  async listCategories(): Promise<CategoryMeta[]> {
    try {
      const response = await apiClient.get('/categories');
      return response.data.categories || response.data || [];
    } catch (error) {
      logger.apiError('listing categories', error);
      throw error;
    }
  }

  async getCategoryBySlug(slug: string): Promise<CategoryMeta> {
    try {
      const response = await apiClient.get(`/categories/${slug}`);
      return response.data.category || response.data;
    } catch (error) {
      logger.apiError('fetching category by slug', error);
      throw error;
    }
  }
}

export default new CategoryService();
